export default __webpack_public_path__ + "static/media/Valka's Woe Hymn.356cfd95.jpg";